/* Asesoria de estilo por WhatsApp.
   Reescribe el enlace "Pedir asesoria de estilo" del mezclador para que abra
   WhatsApp con las piezas que el cliente esta viendo. Sin esto, Danely tendria
   que preguntar "que estabas viendo?" y se pierde media atencion personalizada.
   Vive aparte de monara-mixer.js para poder parchearlo sin resubir 16 KB. */
(function () {
  'use strict';

  var cfg = window.mmSettings || {};

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('es-MX', { maximumFractionDigits: 0 }) + ' MXN';
  }

  function piezasActivas(root) {
    var bandas = root.querySelectorAll('[data-mm-band]');
    var out = [];
    Array.prototype.forEach.call(bandas, function (band) {
      var track = band.querySelector('[data-mm-band-track]');
      var items = band.querySelectorAll('[data-mm-band-item]');
      if (!track || !items.length) return;
      var w = items[0].getBoundingClientRect().width || 1;
      var i = Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / w)));
      var el = items[i];
      if (!el || !el.dataset.mmProductTitle) return;
      out.push({
        title: el.dataset.mmProductTitle,
        price: parseInt(el.dataset.mmPrice, 10) || 0
      });
    });
    return out;
  }

  function actualizar() {
    var root = document.querySelector('[data-mm-mixer]');
    if (!root) return;
    var enlace = root.querySelector('.mm-mixer__advisor');
    if (!enlace) return;

    var tel = cfg.conciergePhone;

    // Sin numero configurado en Personalizar, el enlace conserva su destino.
    if (!tel) return;

    var piezas = piezasActivas(root);
    if (!piezas.length) return;

    var lista = piezas.map(function (p) {
      return '· ' + p.title + ' (' + money(p.price) + ')';
    }).join('\n');

    var total = piezas.reduce(function (s, p) { return s + p.price; }, 0);

    var texto = (cfg.conciergeMessage || 'Hola, estoy armando un look en la tienda y me gustaria tu opinion.')
      + '\n\n' + lista
      + '\n\nTotal: ' + money(total)
      + '\n' + window.location.href;

    enlace.setAttribute('href', 'https://wa.me/' + tel + '?text=' + encodeURIComponent(texto));
    enlace.setAttribute('target', '_blank');
    enlace.setAttribute('rel', 'noopener');
  }

  function init() {
    actualizar();
    var root = document.querySelector('[data-mm-mixer]');
    if (!root) return;
    // El mensaje se rearma conforme el cliente cambia de pieza.
    root.querySelectorAll('[data-mm-band-track]').forEach(function (t) {
      var raf = null;
      t.addEventListener('scroll', function () {
        if (raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(actualizar);
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
